import styled from 'styled-components';

export const SvgLineWrapper = styled.div`
  position: relative;
  z-index: 0;
`;

export const SvgLine = styled.svg`
  position: fixed;
  top: 0;
  left: 0;
  margin-top: 10px;
  pointer-events: none;
  width: 100%;
  height: 100%;
  z-index: 0;
`;
